import React, { useState } from 'react';
import IngredientManagement from './IngredientManagement';
import RecipeManagement from './RecipeManagement';
import InventoryReports from './InventoryReports';

const InventoryDashboard = () => {
    const [activeTab, setActiveTab] = useState('ingredients');

    const tabs = [
        { id: 'ingredients', label: 'Ingredients', icon: '🥕' },
        { id: 'recipes', label: 'Recipes', icon: '📝' },
        { id: 'reports', label: 'Reports', icon: '📊' }
    ];

    const renderContent = () => {
        switch (activeTab) {
            case 'ingredients':
                return <IngredientManagement />;
            case 'recipes':
                return <RecipeManagement />;
            case 'reports':
                return <InventoryReports />;
            default:
                return <IngredientManagement />;
        }
    };

    return (
        <div className="min-h-screen bg-stone-100">
            <div className="sticky top-0 z-10 bg-white border-b border-stone-200 shadow-sm">
                <div className="px-3 py-2 sm:px-5 sm:py-2">
                    <div className="flex flex-wrap items-center gap-2">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`px-3 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all ${
                                    activeTab === tab.id
                                        ? 'bg-orange-500 text-white shadow-md'
                                        : 'bg-white text-stone-600 border border-stone-200 hover:bg-stone-50'
                                }`}
                            >
                                <span className="mr-1.5">{tab.icon}</span>
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            <div className="p-3 sm:p-5">
                {renderContent()}
            </div>
        </div>
    );
};

export default InventoryDashboard;